/*
 *
 * EasySplitPayments constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/EasySplitPayments';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SEARCH_PAYMENTS = `${BASE_ACTION_CONSTANT}/SEARCH_PAYMENTS`;

export const SAVE_PAYMENTS = `${BASE_ACTION_CONSTANT}/SAVE_PAYMENTS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const EXPORT_TO_CSV = `${BASE_ACTION_CONSTANT}/EXPORT_TO_CSV`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const HEADINGS = [
  {
    key: 'createdAt',
    displayName: 'Date & Time',
    width: 0.2,
    tooltip: {
      message: 'Payments Created On',
    },
  },
  {
    key: 'orderId',
    displayName: 'Order ID',
    width: 0.2,
  },
  {
    key: 'customerName',
    displayName: 'Customer Name',
    width: 0.2,
  },
  {
    key: 'orderAmount',
    displayName: 'Order Amount',
    width: 0.2,
    align: 'right',
  },
  {
    key: 'transactionId',
    displayName: 'Transaction ID',
    width: 0.2,
  },
  {
    key: 'txnAmount',
    displayName: 'Transaction Amount',
    width: 0.2,
    align: 'right',
    tooltip: {
      message: 'Transaction Amount',
    },
  },
  {
    key: 'customerPhone',
    displayName: 'Phone No.',
    width: 0.2,
  },
  {
    key: 'paymentMode',
    displayName: 'Payment Mode',
    width: 0.2,
  },
  // {
  //   key: 'settlementAmount',
  //   displayName: 'Settlement Amount',
  //   width: 0.15,
  //   align: 'right',
  // },
];

export const SEARCH_EASY_SPLIT_PAYMENTS_URL = {
  url: '/pg/split/transactions/search',
  method: 'GET',
};

// The values should change accordingly
export const EASY_SPLIT_PAYMENTS_DATA_MAPPER = {
  cfOrderId: 'CF Order ID',
  customerEmail: 'Customer Email',
  customerName: 'Customer Name',
  customerPhone: 'Customer Phone',
  eligibilityTime: 'Eligibility Time',
  isBlocked: 'Is Blocked',
  orderId: 'Order ID',
  pgServiceCharge: 'PG Service Charge',
  pgServiceTax: 'PG Service Tax',
  splitServiceCharge: 'Split Service Charge',
  splitServiceTax: 'Split Service Tax',
  transactionId: 'Transaction ID',
  txTime: 'Transaction Time',
  txnAmount: 'Transaction Amount',
  txnCurrency: 'Transaction Currency',
  txnPaymentMode: 'Transaction Payment Mode',
  vendorCommission: 'Vendor Commission',
  vendorSettlementAmount: 'Vendor settlement Amount',
};
